import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { Icon, LinkButton } from '@eluve/components';

import { ExperimentsBreadcrumbs } from './ExperimentsBreadcrumbs';
import { FactVerifactionBreadcrumbs } from './FactVerifactionBreadcrumbs';
import { OutputTemplateBreadcrumbs } from './OutputTemplateBreadcrumbs';
import { PromptBreadCrumbs } from './PromptBreadcrumbs';
import { SiteBannersBreadcrumbs } from './SiteBannersBreadcrumbs';
import { TemplateBundleBreadcrumbs } from './TemplateBundleBreadcrumbs';
import { TenantBreadCrumbs } from './TenantBreadcrumbs';
import { UserBreadcrumbs } from './UserBreadcrumbs';

export interface AdminBreadcrumbsProps {}

export const AdminBreadcrumbs: React.FC<AdminBreadcrumbsProps> = () => {
  const { tenantId, appointmentId } = useParams() as {
    tenantId: string;
    appointmentId?: string;
  };

  const location = useLocation();
  const isAdminRoot = location.pathname.endsWith('/admin');
  const isPrompts = location.pathname.includes('prompts');
  const isFactVerification = location.pathname.includes('fact-verification');
  const isOutputTemplates = location.pathname.includes('output-templates');
  const isUsers = location.pathname.includes('users');
  const isSiteBanners = location.pathname.includes('site-banners');
  const isExperiments = location.pathname.includes('experiments');
  const isTemplateBundles =
    location.pathname.includes('template-bundles') && !tenantId;

  if (isAdminRoot) {
    return null;
  }

  return (
    <nav className="-m-2 flex" aria-label="Breadcrumb">
      <ol className="flex w-full flex-row items-center">
        <li>
          <div>
            <LinkButton variant="ghost" to="/admin">
              <Icon name="Home" size="auto" />
              Admin Home
            </LinkButton>
          </div>
        </li>
        {tenantId && (
          <TenantBreadCrumbs
            tenantId={tenantId}
            appointmentId={appointmentId}
          />
        )}
        {isPrompts && <PromptBreadCrumbs />}
        {isFactVerification && <FactVerifactionBreadcrumbs />}
        {isOutputTemplates && <OutputTemplateBreadcrumbs />}
        {isUsers && !isPrompts && <UserBreadcrumbs />}
        {isSiteBanners && <SiteBannersBreadcrumbs />}
        {isExperiments && <ExperimentsBreadcrumbs />}
        {isTemplateBundles && <TemplateBundleBreadcrumbs />}
      </ol>
    </nav>
  );
};
